import { Method } from 'state-line';
import BaseApi from './Base';

// 公共
export default (server: string) => ({

  // 文件上传
  UploadFile: class extends BaseApi<{
    // 文件
    file: any,
  }> {
    method: Method = Method.Post;
    url = `${server}/api/file/upload`;
    isFormData = true;
  },

});
